import React from 'react';
import { connect, useDispatch, useSelector } from 'react-redux';
import { useHistory, useParams, useLocation, useRouteMatch } from "react-router-dom";
import {Button, Box} from '@material-ui/core';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import Fade from '@material-ui/core/Fade';
import { makeStyles, createStyles, Theme, useTheme } from '@material-ui/core/styles';
import Icon from '@material-ui/core/Icon';
import languages from 'locales';
import GlobalActions from '../stores/global/actions';
import Languages from 'locales';
import _ from 'lodash'

interface ImenuItem {
  label: string,
  locale: string,
  id: number
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    menuItem: {
      fontSize: 14
    }
  })
)

const LanguageMenu = (props:any) => {
    const {onChange} = props;
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const classes = useStyles();
    const global = useSelector( (state:any) => state.global);
    const location = useLocation();
    const params: {lang?:string} = useParams();
    const history = useHistory();
    const selectedIndex = languages[global.locale].id;
    const open = Boolean(anchorEl);
    const dispatch = useDispatch()
    const LangsKeys = _.values(Languages);
    const langPathMerage = LangsKeys.length > 1 ? _.chain(LangsKeys).reduce((a,b) => a.keys +  `|${b.keys}`).value() : LangsKeys[0].keys;
    const langPathRegex = `^/${_.chain(langPathMerage.split('|')).reduce((a,b) => `${a}` +  `|^/${b}`).value()}`

  const onChangeLanguage = (action: any) => {
    const matchLang:any = location.pathname.match(new RegExp(langPathRegex));
    let pathname = location.pathname;
    
    if(!!matchLang) {
      const path = matchLang.input.split('/')
      pathname = location.pathname.replace(`/${path[1]}`, '');
    }

    history.replace({pathname: `/${action.locale}${pathname === '/' ? '' : pathname}`})
    dispatch(GlobalActions.changeLanguage(action));
  }

  function handleClick(event: React.MouseEvent<HTMLElement>) {
    setAnchorEl(event.currentTarget);
  }

  function onMenuClose() {
    setAnchorEl(null);
  }

  function onSelectionchange(event:any, item: ImenuItem) {
    onChangeLanguage({locale: item.locale});
    if(typeof onChange === 'function') {
      onChange(item.locale)
    }
    onMenuClose();
  }

  return (
    <Box {...props}>
      <Button fullWidth style={{ color: props.color || '#000' }} aria-controls="fade-menu" aria-haspopup="true" onClick={handleClick}>
        <span >{languages[global.locale].label}</span> <Icon style={{fontSize: 14}}>arrow_drop_down</Icon>
      </Button>
      <Menu
        id="fade-menu"
        anchorEl={anchorEl}
        keepMounted
        open={open}
        onClose={onMenuClose}
        TransitionComponent={Fade}
      >
        {
          Object.keys(languages).map((key:any, index:any) => {
            const item:any = languages[key];
            return (
              <MenuItem
              className={classes.menuItem}
              key={index}
              disabled={index === selectedIndex}
              selected={index === selectedIndex}
              onClick={event => onSelectionchange(event, item)}
            >
              {item.label}
            </MenuItem>
            )
          })
        }
      </Menu>
    </Box>
  );
}

export default LanguageMenu